<template>
  <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav> -->
  <div>
    <!-- 顶部导航栏 -->
    <topNav></topNav>
    <router-view/>
    <footer-view class="footer-view"></footer-view>
  </div>

</template>
<script>
import topNav from './components/top-nav.vue'
import footerView from './components/footer-view.vue'
export default {
  name: 'App',
  components: {
    topNav,
    footerView
  }

}
</script>
<style lang="scss">
html,body {
  margin: 0;
  padding: 0;
  position: relative;
  font-size:calc(100vw / 19.2)
}
div,span,p,h1,h2{
  font-size: 0.16rem;
}
@-webkit-keyframes footerBox {
    /* 竖线的动画效果：以百分比来规定改变发生的时间，0% 是动画的开始时间，100% 动画的结束时间 */
    0% {
        opacity: 0;
        transform: translateY(100%);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
}
.footer-view{
  position: absolute;
  bottom: 0;
  left: 0;
    //-webkit-animation: footerBox 2.5s linear;
}
</style>
